import React from "react";
import "../../styles/Loader.css";

const Loader = ({ text = "Cargando datos..." }) => (
  <div className="modern-loader-container">
    <div className="modern-spinner" />
    <span className="modern-loader-text">{text}</span>
  </div>
);

export default Loader;
